// extracted by mini-css-extract-plugin
export var container = "_gi-1";
export var cornerButtonContainer = "_gi-6";
export var disabled = "_gi-2";
export var dragActive = "_gi-3";
export var fileContainer = "_gi-5";
export var hiddenInput = "_gi-4";
export var widthContainer = "_gi-0";